export default __webpack_public_path__ + "media/images/images/pages/ubuntu-type-scale-121aa902c809fcd2b1a1546a1be93ffe.png";